// extracted by mini-css-extract-plugin
module.exports = {"reportsPage":"FfV5i"};